module.exports = __webpack_public_path__ + "img/qianming-icon.8d01831b.png";